import * as Yup from 'yup'
export const Schema = Yup.object().shape({
    amount: Yup.string().required('مبلغ برداشت ضروری می باشد'),
    tag: Yup.string().required('توضیحات ضروری می باشد'),
})
